// modules
import { compose, createStore } from 'redux'
// components
import reducer from '../components/main/emojiPicker.reducer'

/* eslint-disable no-underscore-dangle */
const composeEnhancers =
  typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        name: 'emoji',
      })
    : compose
/* eslint-enable */

const store = createStore(reducer, composeEnhancers())

export const { dispatch, getState } = store
export default store
